module.exports = __webpack_public_path__ + "img/call.09f82ead.svg";